<template>
  <div>
    <page-loading
      v-if="loading"
      message="Carregando transações"
      subtitle="Organizando o histórico de vendas"
    />
    <template v-else>
    <div class="header">
      <v-col cols="12" md="4">
        <v-dialog ref="dialog" v-model="dialog" persistent width="290px">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="handleFormatDate"
              label="Período de vendas"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="selectedRange" range locale="pt-br">
            <v-spacer></v-spacer>
            <v-btn @click="closeDialog" color="primary">Cancelar</v-btn>
            <v-btn @click="dialog = !dialog" color="primary">Ok</v-btn>
          </v-date-picker>
        </v-dialog>
      </v-col>
      <v-col v-if="!hasNoFranchiseFilterProfile" cols="12" md="6">
        <v-select
          :items="sessionFranchises"
          v-model="franchiseId"
          :item-text="displayTextFranchise"
          item-value="id"
          label="Franquia"
        ></v-select>
      </v-col>
      <v-col cols="12" md="2" align-self="center">
        <v-btn block @click="handleGetTransactions" elevation="0" color="#e5183d" dark
          >Buscar</v-btn
        >
      </v-col>
    </div>
    <v-card>
      <v-card-title>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Pesquise pelo documento do parceiro, nome do parceiro, valor da venda ou comissão"
            />
          </v-col>
        </v-row>
      </v-card-title>
      <v-data-table
        :header-props="{ sortByText: 'Filtrar por' }"
        :headers="headers"
        :items="transactions"
        :items-per-page="10"
        :footer-props="{ 'items-per-page-text': 'transações por página' }"
        :search="search"
        no-data-text="Nenhuma transação encontrada"
        class="elevation-0"
      >
        <template v-slot:body="{ items }">
          <tbody>
            <tr v-for="item in items" :key="item.id">
              <td class="d-block d-sm-table-cell">{{ formatDate(item.createdAt) }}</td>
              <td class="d-block d-sm-table-cell">{{ item.partnerName }}</td>
              <td class="d-block d-sm-table-cell">{{ formatDocument(item.partnerDocument) }}</td>
              <td class="d-block d-sm-table-cell">R$ {{ formatPrice(item.value) }}</td>
              <td class="d-block d-sm-table-cell">R$ {{ formatPrice(commissionValue(item)) }}</td>
              <td class="d-block d-sm-table-cell">{{ paymentMethodLabel(item.paymentMethod) }}</td>
              <td class="d-block d-sm-table-cell"><status-badge-vue :status="item.status" /></td>
              <td class="d-block d-sm-table-cell">
                <v-icon size="24" color="#e5183d" @click="handleDetailPartner(item.id)"
                  >mdi-menu</v-icon
                >
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="openTransactionDetail" max-width="700">
      <v-card>
        <v-card-title class="headline">Detalhes da transação</v-card-title>
        <v-card-text>
          <div v-if="loadingTransactionDetail">Carregando detalhes...</div>
          <v-row v-else-if="transactionDetail">
            <v-col cols="12" md="6">
              <p class="subtitle-1 mb-1">ID</p>
              <p class="subtitle-2 font-weight-bold">{{ transactionDetail.id }}</p>
            </v-col>
            <v-col cols="12" md="6">
              <p class="subtitle-1 mb-1">Data</p>
              <p class="subtitle-2 font-weight-bold">{{ formatDate(transactionDetail.createdAt) }}</p>
            </v-col>
            <v-col cols="12" md="6">
              <p class="subtitle-1 mb-1">Valor</p>
              <p class="subtitle-2 font-weight-bold">R$ {{ formatPrice(transactionDetail.value) }}</p>
            </v-col>
            <v-col cols="12" md="6">
              <p class="subtitle-1 mb-1">{{ commissionLabel }}</p>
              <p class="subtitle-2 font-weight-bold">
                R$ {{ formatPrice(commissionValue(transactionDetail)) }}
              </p>
            </v-col>
            <v-col cols="12" md="6">
              <p class="subtitle-1 mb-1">Forma de pagamento</p>
              <p class="subtitle-2 font-weight-bold">
                {{ paymentMethodLabel(transactionDetail.paymentMethod) }}
              </p>
            </v-col>
            <v-col cols="12" md="6">
              <p class="subtitle-1 mb-1">Status</p>
              <p class="subtitle-2 font-weight-bold">{{ transactionDetail.status }}</p>
            </v-col>

            <v-col cols="12"><v-divider /></v-col>

            <v-col cols="12"><h3 class="text-subtitle-1 mb-2">Parceiro</h3></v-col>
            <v-col cols="12" md="6">
              <p class="subtitle-1 mb-1">Nome</p>
              <p class="subtitle-2 font-weight-bold">
                {{ transactionDetail.partner?.name || transactionDetail.partnerName || "-" }}
              </p>
            </v-col>
            <v-col cols="12" md="6">
              <p class="subtitle-1 mb-1">Documento</p>
              <p class="subtitle-2 font-weight-bold">
                {{ formatDocument(transactionDetail.partner?.document || transactionDetail.partnerDocument || "") }}
              </p>
            </v-col>
            <v-col cols="12" md="6">
              <p class="subtitle-1 mb-1">E-mail</p>
              <p class="subtitle-2 font-weight-bold">{{ transactionDetail.partner?.email || "-" }}</p>
            </v-col>
            <v-col cols="12" md="6">
              <p class="subtitle-1 mb-1">Telefone</p>
              <p class="subtitle-2 font-weight-bold">
                {{ transactionDetail.partner?.phone ? phoneNumberFormat(transactionDetail.partner.phone) : "-" }}
              </p>
            </v-col>
            <v-col cols="12" md="6">
              <p class="subtitle-1 mb-1">Cidade/Estado</p>
              <p class="subtitle-2 font-weight-bold">
                {{ transactionDetail.partner?.cityName && transactionDetail.partner?.state
                  ? `${transactionDetail.partner.cityName} - ${transactionDetail.partner.state}`
                  : "-" }}
              </p>
            </v-col>

            <v-col cols="12"><v-divider /></v-col>

            <v-col cols="12"><h3 class="text-subtitle-1 mb-2">Consumidor</h3></v-col>
            <v-col cols="12" md="6">
              <p class="subtitle-1 mb-1">Nome</p>
              <p class="subtitle-2 font-weight-bold">{{ transactionDetail.customer?.name || "-" }}</p>
            </v-col>
            <v-col cols="12" md="6">
              <p class="subtitle-1 mb-1">Documento</p>
              <p class="subtitle-2 font-weight-bold">
                {{ formatDocument(transactionDetail.customer?.document || "") || "-" }}
              </p>
            </v-col>
            <v-col cols="12" md="6">
              <p class="subtitle-1 mb-1">E-mail</p>
              <p class="subtitle-2 font-weight-bold">{{ transactionDetail.customer?.email || "-" }}</p>
            </v-col>
            <v-col cols="12" md="6">
              <p class="subtitle-1 mb-1">Telefone</p>
              <p class="subtitle-2 font-weight-bold">
                {{ transactionDetail.customer?.phone ? phoneNumberFormat(transactionDetail.customer.phone) : "-" }}
              </p>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="closeTransactionDetail">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageLoading from "@/components/loading/PageLoading.vue";

import StatusBadgeVue from "@/components/statusBadge/StatusBadge.vue";

import { TransactionType } from "@/types/transaction/Transaction";
import { GetTransactions } from "@/services/transactions/GetTransactions";
import { GetTransactionDetails, TransactionDetailsType } from "@/services/transactions/GetTransactionDetails";
import { format } from "date-fns";
import { SessionFranchiseType } from "@/types/user/SessionInfo";

interface SortItem {
  name: string;
  phone: string;
  createdAt: string;
}

export default defineComponent({
  components: { StatusBadgeVue, PageLoading },
  data() {
    const today = new Date();
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(today.getDate() - 30);
    const formattedToday = today.toISOString().split("T")[0];
    const formattedThirtyDaysAgo = thirtyDaysAgo.toISOString().split("T")[0];
    return {
      dialog: false,
      selectedRange: [formattedThirtyDaysAgo, formattedToday],
      startDate: formattedThirtyDaysAgo,
      endDate: formattedToday,
      mobileBreakpoint: 600,
      loading: true,
      showModal: false,
      showModalRemove: false,
      openTransactionDetail: false,
      loadingTransactionDetail: false,
      transactionDetail: null as TransactionDetailsType | null,
      franchiseId: "",
      transactions: [] as TransactionType[],
      search: "",
      sortBy: [] as ReadonlyArray<SortItem>,
      sortDesc: false,
      noDataText: "Nenhum dado disponível",
    };
  },
  computed: {
    isAssociatesRegistrar(): boolean {
      return this.$store.getters.isAssociatesRegistrar;
    },
    isCollaboratorManagerUser(): boolean {
      return this.$store.getters.isCollaboratorManager;
    },
    effectiveAssociateId(): string {
      if (this.isCollaboratorManagerUser) return "";
      return this.$store.state.session?.associateId ?? "";
    },
    hasNoFranchiseFilterProfile(): boolean {
      return this.$store.getters.hasNoFranchiseFilterProfile;
    },
    commissionLabel(): string {
      return this.hasNoFranchiseFilterProfile
        ? "Comissão do associado"
        : "Comissão da franquia";
    },
    headers(): { text: string; value: string }[] {
      return [
        { text: "Data da venda", value: "createdAt" },
        { text: "Parceiro", value: "partnerName" },
        { text: "Documento do parceiro", value: "partnerDocument" },
        { text: "Valor da venda", value: "value" },
        { text: this.commissionLabel, value: "commissionAmount" },
        { text: "Forma de pagamento", value: "paymentMethod" },
        { text: "Status", value: "status" },
        { text: "Ações", value: "actions" },
      ];
    },
    sessionFranchises(): SessionFranchiseType[] {
      return this.$store.getters.sessionFranchises;
    },
    handleFormatDate(): string[] {
      const datesString = this.selectedRange?.map((dates: string | undefined) => {
        if (dates) {
          const [year, month, day] = dates.split("-");
          return ` ${day}/${month}/${year}`;
        }
        return "";
      });
      return datesString || [];
    },
  },
  watch: {
    sessionFranchises: {
      handler(franchises: SessionFranchiseType[]) {
        if (this.hasNoFranchiseFilterProfile) {
          this.handleGetTransactions();
          return;
        }
        if (franchises.length > 0 && !this.franchiseId) {
          this.franchiseId = franchises[0].id;
          this.handleGetTransactions();
          return;
        }
        if (franchises.length === 0) {
          this.loading = false;
        }
      },
      immediate: true,
    },
    franchiseId(newValue: string) {
      if (this.hasNoFranchiseFilterProfile) return;
      if (!newValue) {
        this.transactions = [];
      }
    },
  },
  methods: {
    closeDialog() {
      this.dialog = false;
    },
    async handleGetTransactions() {
      this.loading = true;
      const associateId = this.hasNoFranchiseFilterProfile ? this.effectiveAssociateId : undefined;
      const canLoadAllAssociates =
        (this.isAssociatesRegistrar || this.isCollaboratorManagerUser) && !associateId;
      if (this.franchiseId || associateId || canLoadAllAssociates) {
        const getTransactions = new GetTransactions();
        if (this.selectedRange.length > 0) {
          if (this.selectedRange[0] > this.selectedRange[1]) {
            this.startDate = this.selectedRange[1];
            this.endDate = this.selectedRange[0];
          } else {
            this.startDate = this.selectedRange[0];
            this.endDate = this.selectedRange[1];
          }
        }
        const transactions = await getTransactions.execute(
          this.franchiseId,
          associateId,
          this.startDate,
          this.endDate
        );
        this.transactions = transactions;
        this.transactions = this.transactions
          .filter((transaction: TransactionType) => transaction.status == "CONFIRMED")
          .map((transaction: TransactionType) => ({
            ...transaction,
            commissionAmount: this.commissionValue(transaction),
          }));
      } else {
        this.transactions = [];
      }
      this.loading = false;
    },
    handleNewPartner() {
      this.$router.push({
        name: "partnerForm",
        params: { modeForm: "new" },
      });
    },
    async handleDetailPartner(transactionId: string) {
      this.openTransactionDetail = true;
      this.loadingTransactionDetail = true;
      this.transactionDetail = null;
      try {
        const getTransactionDetails = new GetTransactionDetails();
        this.transactionDetail = await getTransactionDetails.execute(transactionId);
      } finally {
        this.loadingTransactionDetail = false;
      }
    },
    closeTransactionDetail() {
      this.openTransactionDetail = false;
      this.transactionDetail = null;
    },
    phoneNumberFormat: (value: string): string => {
      if (!value) return "";
      const phone = "(" + value.substr(0, 2) + ") " + value.substr(2, 5) + "-" + value.substr(7, 8);
      return phone;
    },
    formatDate: (date: string): string => {
      const dateFormated = format(new Date(date), "dd/MM/yyyy HH:mm:ss");
      return dateFormated;
    },
    formatDocument: (document: string): string => {
      if (document.length === 11) {
        return document.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
      }
      if (document.length === 14) {
        return document.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
      }
      return document;
    },
    formatPrice: (value: number): string => {
      if (!value) return "";
      return value.toFixed(2).replace(".", ",");
    },
    paymentMethodLabel(paymentMethod: string | undefined): string {
      if (paymentMethod === "PIX") return "Pix";
      if (paymentMethod === "CREDIT_CARD") return "Cartão de crédito";
      return "Indefinido";
    },
    displayTextFranchise(item: SessionFranchiseType): string {
      if (item.cityName && item.state) {
        return `${item.cityName} - ${item.state}`;
      }
      return item.name ?? item.id;
    },
    commissionValue(item: { franchiseValue?: number; franchiseAssociateValue?: number }): number {
      if (this.hasNoFranchiseFilterProfile) {
        return Number(item.franchiseAssociateValue ?? 0);
      }
      return Number(item.franchiseValue ?? 0);
    },
  },
});
</script>

<style scoped lang="scss">
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}
</style>
